import * as React from 'react';
import styles from './index.less';
import { Checkbox, Modal } from 'antd';
import * as ReactDOM from 'react-dom/client';
import { FI18n, FUtil } from '@freelog/tools-lib';
import FIcons from '@/components/FIcons';

type getContainerFunc = () => HTMLElement;

interface fPromiseModalConfirmProps {
  title: string;
  description: string;
  okText?: string;
  cancelText?: string;
  promptKey_localStorage?: string;
  getContainer?: string | HTMLElement | getContainerFunc | false;
}

function fPromiseModalConfirm({
  title,
  description,
  okText,
  cancelText,
  promptKey_localStorage = '',
  getContainer,
}: fPromiseModalConfirmProps): Promise<boolean> {

  const storage: string = JSON.parse(self.localStorage.getItem('fPromiseModalConfirm') || '[]');

  if (promptKey_localStorage !== '' && storage.includes(promptKey_localStorage)) {
    return Promise.resolve(true);
  }

  return new Promise<boolean>((resolve) => {
    // const divRoot = self.document.getElementById('modal-root') as HTMLDivElement;
    // const div = self.document.createElement('div') as HTMLDivElement;
    // divRoot.appendChild(div);
    // const root = ReactDOM.createRoot(div);
    const divRoot = self.document.body;
    const div = self.document.createElement('div') as HTMLDivElement;
    divRoot.appendChild(div);
    const root = ReactDOM.createRoot(div);

    return root.render(<Middleware
      title={title}
      getContainer={getContainer}
      description={description}
      okText={okText}
      cancelText={cancelText}
      showPrompt={promptKey_localStorage !== ''}
      onOk={({ remember }) => {
        if (remember) {
          self.localStorage.setItem('fPromiseModalConfirm', JSON.stringify([...storage, promptKey_localStorage]));
        }
        resolve(true);
      }}
      onCancel={() => {
        resolve(false);
      }}
      afterClose={() => {
        setTimeout(() => {
          root.unmount();
          div.remove();
        }, .1);
      }}
    />);
  });
}

export default fPromiseModalConfirm;

interface MiddlewareProps {
  title: string;
  description: string;
  okText?: string;
  cancelText?: string;
  showPrompt?: boolean;
  getContainer?: string | HTMLElement | getContainerFunc | false;

  onOk?(config: { remember: boolean }): void;

  onCancel?(): void;

  afterClose?(): void;
}

function Middleware({
  title,
  description,
  okText,
  cancelText,
  onOk,
  onCancel,
  afterClose,
  showPrompt,
  getContainer,
}: MiddlewareProps) {
  const [$visible, set$visible] = FUtil.Hook.useGetState<boolean>(true);
  const [$checked, set$checked, get$checked] = FUtil.Hook.useGetState<boolean>(false);
  const titleTrimmed = title.trim();
  const hasTitle = titleTrimmed.length > 0;

  return (
    <Modal
      getContainer={getContainer}
      title={null}
      open={$visible}
      footer={null}
      closable={false}
      centered
      className={styles.modal}
      width="min(max-content, calc(100vw - 48px))"
      onCancel={() => {
        set$visible(false);
        onCancel && onCancel();
      }}
      afterClose={() => {
        afterClose && afterClose();
      }}
      maskClosable={false}
      styles={{
        body: {
          padding: 0,
        },
        content: {
          padding: hasTitle ? 30 : '60px 30px 30px',
          borderRadius: 4,
          boxSizing: 'border-box',
        },
      }}
      style={{
        borderRadius: 4,
        overflow: 'hidden',
        maxWidth: 'calc(100vw - 48px)',
      }}
    >
      <div
        className={[styles.modelContent, hasTitle ? '' : styles.modelContentNoTitle]
          .filter(Boolean)
          .join(' ')}
      >
        {hasTitle ? (
          <div className={styles.headerRow}>
            <div className={styles.headerSpacer} aria-hidden />
            <div className={styles.titleWrap}>
              <span className={styles.titleText}>{titleTrimmed}</span>
            </div>
            <div className={styles.headerClose}>
              <button
                type="button"
                className={styles.closeBtn}
                onClick={() => {
                  set$visible(false);
                  onCancel && onCancel();
                }}
              >
                <FIcons.FClose style={{ fontSize: 16, color: '#000' }} />
              </button>
            </div>
          </div>
        ) : null}
        <div className={styles.descArea}>
          <span className={styles.descText}>{description}</span>
        </div>
        <div className={styles.btn}>
          <button
            type="button"
            className={styles.cancelBtn}
            onClick={() => {
              set$visible(false);
              onCancel && onCancel();
            }}
          >
            {cancelText ||
              // 取消
              FI18n.i18nNext.tAuto('btn_cancel')}
          </button>
          <button
            type="button"
            className={styles.okBtn}
            onClick={() => {
              set$visible(false);
              onOk && onOk({ remember: get$checked() });
            }}
          >
            {okText || '确定'}
          </button>
        </div>
        {showPrompt && (
          <div
            className={styles.checkboxRow}
            onClick={() => {
              set$checked(!get$checked());
            }}
          >
            <Checkbox checked={$checked} />
            <span className={styles.checkboxText}>
              {
                // 不再提示
                FI18n.i18nNext.tAuto('checkbox_dontaskmeagain')
              }
            </span>
          </div>
        )}
      </div>
    </Modal>
  );
}
